import React from 'react';
import PropTypes from 'prop-types';

import { HtmlSafe } from 'polaris-coreweb/exports';
import { withPolaris } from 'Components/protons/Polaris';

import './_style.scss';

const InfoBlock = ({
  data: { title, content },
  context: { cssPrefix },
}) => (
  <div className={`${cssPrefix}__info-block`}>
    <div className={`${cssPrefix}__info-block--icon`} />
    <div className={`${cssPrefix}__info-block--content`}>
      <p className={`${cssPrefix}__info-block--title`}>{title}</p>
      <div className={`${cssPrefix}__info-block--summary`}>
        {content && typeof content === 'string' && (
          <HtmlSafe html={content} />
        )}
      </div>
    </div>
  </div>
);

InfoBlock.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
  }),
  data: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.string,
  }),
};

InfoBlock.defaultProps = {
  context: {},
  data: {
    title: '',
    content: '',
  },
};

export default withPolaris(InfoBlock);
